/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandThumbUpIcon24Solid = forwardRef('HandThumbUpIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.95 2.223a2.126 2.126 0 0 1 4.05.903V8h4.541a3 3 0 0 1 2.892 3.801l-1.712 6.176A4.125 4.125 0 0 1 16.746 21H7.5V8.76c.334-.188.61-.478.78-.84l2.67-5.697Z" }),
        React.createElement("path", { d: "M3.75 9A1.75 1.75 0 0 0 2 10.75v8.5c0 .966.784 1.75 1.75 1.75H6V9H3.75Z" })));
});
